export default __webpack_public_path__ + "static/media/img-empty.3eb988bf.svg";